import {
  GetAreaTargetsCollection,
  GetSingleAreaTargets,
  UpdateAreaTargets,
  AddAreaTargets,
  DeleteAreaTargets,
} from "../settings/settings_area_target_service_actions";
import { actionTypes } from "../action_types";

export const GetBranchTargetsCollection = (data) => (dispatch) => {
  return GetAreaTargetsCollection(data).then((resp) => {
    if (resp.problem === null) {
      dispatch({
        type: actionTypes.REPORTS_SETTINGS_BRANCH_TARGET_GET_COLLECTION,
        payload: resp.data !== null ? resp.data : [],
      });
    }
    return Promise.resolve(resp);
  });
};

export const GetSingleBranchTargets = (data) => (dispatch) => {
  return GetSingleAreaTargets(data).then((resp) => {
    if (resp.problem === null) {
      dispatch({
        type: actionTypes.REPORTS_SETTINGS_BRANCH_TARGET_GET_SINGLE,
        payload: resp.data !== null ? resp.data : [],
      });
    }
    return Promise.resolve(resp);
  });
};

export const AddBranchTargets = (data) => (dispatch) => {
  return AddAreaTargets(data).then((resp) => {
    if (resp.problem === null) {
      dispatch({
        type: actionTypes.REPORTS_SETTINGS_BRANCH_TARGET_ADD,
        payload: resp.data !== null ? resp.data : [],
      });
    }
    return Promise.resolve(resp);
  });
};

export const UpdateBranchTargets = (data) => (dispatch) => {
  return UpdateAreaTargets(data).then((resp) => {
    if (resp.problem === null) {
      dispatch({
        type: actionTypes.REPORTS_SETTINGS_BRANCH_TARGET_UPDATE,
        payload: resp.data !== null ? resp.data : [],
      });
    }
    return Promise.resolve(resp);
  });
};

export const DeleteBranchTargets = (data) => (dispatch) => {
  return DeleteAreaTargets(data).then((resp) => {
    if (resp.problem === null) {
      dispatch({
        type: actionTypes.REPORTS_SETTINGS_BRANCH_TARGET_DELETE,
        payload: resp.data !== null ? resp.data : [],
      });
    }
    return Promise.resolve(resp);
  });
};
